import { render, staticRenderFns } from "./CopilotoRutas.vue?vue&type=template&id=d2f68498&"
import script from "./CopilotoRutas.vue?vue&type=script&lang=ts&"
export * from "./CopilotoRutas.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('d2f68498', component.options)
    } else {
      api.reload('d2f68498', component.options)
    }
    module.hot.accept("./CopilotoRutas.vue?vue&type=template&id=d2f68498&", function () {
      api.rerender('d2f68498', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/CopilotoVirtual/Ruta/CopilotoRutas.vue"
export default component.exports